import { MaritalStatus } from '../../../../../common/enums/maritalStatus';

export function emptyPatient(
    identifierSocialSecurity?: string | null,
    birthDate?: string | null,
    nameFamily?: string | null,
    processNumber?: string | null
) {
    return {
        birthDate: birthDate ?? null,
        careProviderOrganizationId: null,
        careProviderPractitionerId: null,
        city: null,
        country: 'NL',
        deceasedDate: null,
        emailAddress: null,
        gender: null,
        homePhoneNumber: null,
        houseLetter: null,
        houseNumber: null,
        houseNumberSuffix: null,
        id: undefined,
        identifierInsurance: null,
        identifierSocialSecurity: identifierSocialSecurity ?? null,
        isActive: true,
        isDeceased: false,
        maritalStatus: MaritalStatus.unknown,
        mobileNumber: null,
        nameFamily: nameFamily ?? null,
        nameFamily2: null,
        nameGiven: null,
        nameInfix: null,
        nameInfix2: null,
        nameUsual: null,
        processNumber: processNumber ?? null,
        profession: null,
        state: null,
        street: null,
        zip: null,
    };
}
